import { Chip } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { LiveStream } from '../../../interfaces/interfaces';

interface LivestreamStatusTagsProps {
  stream?: LiveStream;
  className?: string;
  mode?: 'row' | 'col';
}
export const LivestreamStatusTags = (props: LivestreamStatusTagsProps) => {
  const { stream, mode = 'col', className = '' } = props;
  const { t } = useTranslation();

  if (!stream) return <></>;

  const StatusChip = (label: string, animate: boolean, backgroundColor?: string, color?: string) => (
    <Chip
      style={{ ...(backgroundColor ? { backgroundColor } : {}), ...(color ? { color } : {}) }}
      className={`${animate ? 'animate-pulse' : ''}`}
      variant="outlined"
      label={label}
    />
  );

  return (
    <div className={`flex ${mode === 'row' ? 'flex-row space-x-2' : 'flex-col space-y-2'} ${className}`}>
      {StatusChip(
        stream.isBroadcasting ? t('account:livestream.broadcasting') : t('account:livestream.idle'),
        stream.isBroadcasting,
        stream.isBroadcasting ? 'red' : undefined,
        stream.isBroadcasting ? 'white' : undefined
      )}
      {StatusChip(
        stream.isEncoderConnected ? t('account:livestream.encoder-connected') : t('account:livestream.encoder-disconnected'),
        stream.isEncoderConnected
      )}
    </div>
  );
};
